'use client';

import * as React from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

import { cn } from '@/lib/utils';

const HoverCard = React.forwardRef((props, ref) => (
  <HoverCardPrimitive.Root ref={ref} {...props} />
));
HoverCard.displayName = 'HoverCard';


const HoverCardTrigger = React.forwardRef((props, ref) => (
  <HoverCardPrimitive.Trigger ref={ref} {...props} />
));
HoverCardTrigger.displayName = 'HoverCardTrigger';


const HoverCardContent = React.forwardRef(
  ({ className, children, align = 'center', sideOffset = 4, ...props }, ref) => (
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    >
      {children}
    </HoverCardPrimitive.Content>
  )
);
HoverCardContent.displayName = 'HoverCardContent';



export { HoverCard, HoverCardTrigger, HoverCardContent };
